export default {"src":"/_next/static/media/tada.45c2d924.svg","height":184,"width":184};